import React from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateUserDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { UploadFile } from '../File/UploadFile';

interface UserEditorTabDoctorProps {
  user: CreateUpdateUserDto | undefined;
  propertyChange: (obj: Partial<CreateUpdateUserDto>) => void;
}

export const UserEditorTabDoctor: React.FC<UserEditorTabDoctorProps> = ({
  user,
  propertyChange,
}) => {
  return (
    <Form className="d-grid gap-3">
      <FormRow controlId="user_description" label="Numer uprawnień">
        <Form.Control
          type="text"
          value={user?.licenseNumber || ''}
          onChange={e => propertyChange({ licenseNumber: e.target.value })}
        />
      </FormRow>
      <FormRow controlId="pwz" label="Numer PWZ">
        <Form.Control
          type="text"
          value={user?.pwz || ''}
          onChange={e => propertyChange({ pwz: e.target.value })}
        />
      </FormRow>
      <FormRow
        controlId="occupationalMedicineDoctorIdentifier"
        label="Identyfikator lekarza medycyny pracy"
      >
        <Form.Control
          type="text"
          value={user?.occupationalMedicineDoctorIdentifier || ''}
          onChange={e =>
            propertyChange({
              occupationalMedicineDoctorIdentifier: e.target.value,
            })
          }
        />
      </FormRow>
      <FormRow controlId="photo" label="Zdjęcie" className="mt-3">
        <UploadFile
          file={user?.photo || ''}
          setFile={photo => propertyChange({ photo: photo })}
          imageHeight={50}
          buttonText={'Wgraj plik graficzny'}
        />
      </FormRow>
    </Form>
  );
};
